import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'

@Component({
  selector: 'habit-role-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './employee-role-edit.component.html',
  styleUrl: './employee-role-edit.component.scss',
  providers: [HabitsService],
  standalone: true,
})
export class EmployeeRoleEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private employeeRoleService: HabitsService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<EmployeeRoleEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.employeeRoleService.editHabits(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
